export const approvedVendors = [
    {
      vendorId: "12345",
      vendorName: "Sanchit",
    },
    {
      vendorId: "67890",
      vendorName: "Siresha",
    },
  ];
  